module.exports = "<a\n    ng-href=\"{{$parent.row['value']}}\"\n    ng-bind=\"$parent.row['value']\"\n    target = '_blank'>\n</a>"